import { AxiosPromise } from 'axios'
import axios from '../api/axios'
import { Comment } from './types'

export const createComment = (post: number, content: string): AxiosPromise<Comment> =>
  axios.post<Comment>('/orreca/v1/comments', { post, content })

export const deleteComment = (commentId: number): AxiosPromise<Comment> =>
  axios.delete<Comment>(`/orreca/v1/comments/${commentId}`)
